"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _PageItem["default"];
  }
});
var _PageItem = _interopRequireDefault(require("react-bootstrap/lib/PageItem"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/PageItem.js
// module id = 6413
// module chunks = 25